import { render, staticRenderFns } from "./QuizJigsaw.vue?vue&type=template&id=7b6d460c&"
import script from "./QuizJigsaw.vue?vue&type=script&lang=js&"
export * from "./QuizJigsaw.vue?vue&type=script&lang=js&"
import style0 from "./QuizJigsaw.vue?vue&type=style&index=0&id=7b6d460c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports